import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./normalize.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Context
import { ConferencesProvider } from "./context/conferences";
import { TagsProvider } from "./context/tags";
import { VideosProvider } from "./context/videos";

ReactDOM.render(
    <React.StrictMode>
        <ConferencesProvider>
            <TagsProvider>
                <VideosProvider>
                    <App />
                </VideosProvider>
            </TagsProvider>
        </ConferencesProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
